<template>
	<div id='ae' class='' v-loading='loading'>

		<tyc :tqobj='tqobj'></tyc>

		<div v-show="config.data ? config.data.auditContent : false">
			<el-alert style='display:flex;display:-webkit-flex;margin: 0 0 5px 0;' :title="reason" type="error"
				show-icon>
			</el-alert>
		</div>

		<el-dialog class='gDia' :title="$t('app_addPush')" v-model="dialogVisible" size='middle'>
			<div style='width:100%;background:none;text-align:left;' class='gDiaTable'>

				<span>

					<el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="channelId" clearable
						:placeholder="$t('app_distributor')">
						<el-option v-for="item in channels" :key="item.mechanismid" :label="item.mechanismname"
							:value="item.mechanismid">
						</el-option>
					</el-select>
				</span>

				<span>

					<el-select @change='selectChange' style='width:16%;margin-right:10px;' v-model="status" clearable
						:placeholder="$t('app_status')">
						<el-option v-for="item in stModel" :key="item.vl" :label="item.label" :value="item.vl">
						</el-option>
					</el-select>
				</span>


				<el-input :placeholder="$t('app_searchTerminal')" icon="search" @keyup.enter.native='srchDevice'
					style='width:40%;margin-bottom:10px;' v-model="srchValue">
				</el-input>
			</div>




			<el-table :data="tableData" border tooltip-effect="dark" style="width: 100%">
				<el-table-column align='center' prop="terminalNo" :label="$t('app_terNo')" width="150">
				</el-table-column>
				<el-table-column align='center' prop="terminalName" :label="$t('app_terName')" width="130">
				</el-table-column>
				<el-table-column prop="terminal_status" align='center' :label="$t('app_status')" width="90">
					<template slot-scope="scope">
						<el-tag v-if="scope.row.terminalStatus == 1 " type="success"
							size="mini">{{$t('app_online')}}</el-tag>
						<el-tag v-if="scope.row.terminalStatus == 2 " type="danger"
							size="mini">{{$t('app_offline')}}</el-tag>
						<el-tag v-if="scope.row.terminalStatus == 0 " type="gray" size="mini">{{$t('app_new')}}</el-tag>
					</template>
				</el-table-column>
				<el-table-column align='center' prop="mechName" :label="$t('app_distributor')" width=''>
				</el-table-column>
				<el-table-column prop="operate" :label="$t('app_operate')" align='center' width='80'>
					<template slot-scope='scope'>
						<!-- <el-button  @click='bindOperate(scope.row)' type=text>{{$t('app_push')}}</el-button> -->

						<el-tooltip class="item" effect="dark" :content="$t('app_push')" placement="top">
							<el-button type='text' @click='bindOperate(scope.row)'><i class="fa fa-upload"
									style=""></i></el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>

			<div class="gPgDiv" style=''>

				<el-pagination @current-change="pageSelect" @size-change="pageSized" :current-page="index"
					:page-sizes='$gRows' :page-size="$gRow" class='gPg' layout="total, sizes, prev, pager, next, jumper"
					:total="total">
				</el-pagination>
				<!-- <el-pagination
          small
          layout="prev, pager, next"
          :total="total">
        </el-pagination> -->

			</div>

		</el-dialog>

		<el-dialog title="" v-model="showPic.value" size='small'>
			<img :src='showPic.data' style='width:300px;'>
		</el-dialog>

		<div v-show="isShowReason">
			<el-alert style='display:flex;display:-webkit-flex;margin: 0 0 5px 0;' :title="reason" type="error"
				show-icon>
			</el-alert>
		</div>

		<div class='gPageBorder'>


			<el-form class='gForm' ref="form" :model='form' :rules='rules' label-position="right" label-width="12.5%"
				style=''>

				<el-form-item :label="$t('app_filename')" prop='name'>
					<el-input style='' class='aeMg' v-model='form.name'></el-input>
				</el-form-item>

				<el-form-item :label="$t('app_filedesc')" prop=''>
					<el-input style='' class='aeMg' v-model='form.desc'></el-input>
				</el-form-item>

				<el-form-item :label="$t('lin_global.label_type')" prop='dtype'>
					<el-radio-group v-model="form.dtype" @input="change_device">
						<el-radio :label="1">{{ $t('lin_global.device_type_1') }}</el-radio>
						<el-radio :label="2">{{ $t('lin_global.device_type_2') }}</el-radio>
					</el-radio-group>
				</el-form-item>




				<el-form-item :label="$t('app_filetype')" prop='ftype'>
					<el-select @change='fileTypeChange' style='' v-model="form.ftype" :placeholder="$t('app_select')">
						<el-option v-for="item in ftypes" :key="item.vl" :label="item.lb" :value="item.vl">
						</el-option>
					</el-select>

					<!-- &nbsp;&nbsp;&nbsp;<el-button v-show='form.ftype == 3' type='text' @click='jumpToTool'>{{$t('app_ftooltip')}}</el-button> -->

				</el-form-item>

				<el-form-item :label="$t('app_subtype')" prop=''>
					<el-select style='' @change='sfileTypeChange' v-model="form.stype" clearable
						:placeholder="$t('app_select')">
						<el-option v-for="item in cmtypes" :key="item.vl" :label="item.lb" :value="item.vl">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item :label="$t('app_version')" prop='ver'>
					<el-input style='' class='aeMg' :disabled="form.ftype == 11 ? true : false"
						v-model='form.ver'></el-input>
				</el-form-item>

				<el-form-item v-show='isbase' :label="$t('app_preversion')" :prop="isbase?bver:''">
					<el-input style='' class='aeMg' v-model='form.bver'></el-input>
				</el-form-item>

				<!-- <el-form-item v-show='true' :label="$t('app_udState')" prop='appTypeValue' style=''>

            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 99999}"
              v-model='updateDescContent'
              style='width:100%;float:left;'
              class='aeMg'
              >
             </el-input>
        </el-form-item> -->


				<el-form-item :label="$t('app_ulfile')" v-show="true" prop='url'>

					<el-upload class="upload-demo aeMg" :data='uData' drag name='fileUpload' :file-list="fileList"
						:on-success="fileUploadSuccess" :before-upload="fileBeforeUpload" :action="fileUploadUrl">


						<span>
							<i v-if='ulinfo.index === 0' :class="ulinfo.icons[ulinfo.index]"></i>

							<div v-else style='margin-top:22px;color:#48576A;'>

								<i :style=tipColor :class="ulinfo.icons[ulinfo.index]"></i>
								<el-col>
									<el-row style='margin-top:-8px;'>
										<div></div>
										<div style='height:26px;'>{{$t('app_filename')}}:&nbsp;{{form.fname}}</div>
										<div style='height:26px;'>
											{{$t('app_fileSize')}}:&nbsp;{{(form.size/1024).toFixed(2)}}KB
										</div>
										<div style='height:26px;'>MD5:&nbsp;{{form.md5}}</div>
										<div>
											<el-button type='primary'
												style='margin-top:6px;'>{{$t('app_clreul')}}</el-button>
										</div>
									</el-row>
								</el-col>
							</div>
							<div v-show='ulinfo.index === 0' class="el-upload__text">{{ulinfo.tip}}</div>
						</span>

					</el-upload>

					<!-- <el-upload
            v-show='isShowCommon(1)'
            class="upload-demo aeMg"
            :data='uData'
            drag
            name='fileUpload'
            :file-list="fileList"
            :on-success="fileUploadSuccess"
            :before-upload="fileBeforeUpload"
            :action="fileUploadUrl">


            <span>
              <i v-if='ulinfo.index === 0' :class="ulinfo.icons[ulinfo.index]"></i>
              <div v-else style='margin-top:50px;'><i :style=tipColor :class="ulinfo.icons[ulinfo.index]"></i></div>
              <div class="el-upload__text">{{ulinfo.tip}}</div>
            </span>

          </el-upload> -->

				</el-form-item>

				<el-form-item :label="$t('app_useDis')" prop='mech'>
					<MechanismSelector style='' :data="mechanismData"></MechanismSelector>
				</el-form-item>



				<el-form-item v-show='config.type === 3' :label="$t('app_testInstall')"
					style='background:none;margin-top:30px;'>
					<el-button type='primary' class='aeMg' @click='pushInstall'>{{$t('app_pushInstall')}}</el-button>
				</el-form-item>
				<el-form-item v-show='config.type === 3' :label="$t('app_isPass')" style='background:none;'>
					<el-radio class="radio aeMg" v-model="radio" label="1">{{$t('app_pass')}}</el-radio>
					<el-radio class="radio aeMg" v-model="radio" label="2">{{$t('app_ban')}}</el-radio>
				</el-form-item>
				<el-form-item v-show="radio === '2'" :label="$t('app_banReason')" style='background:none;'>
					<textarea v-model='checkDesc' style='width:100%;height:60px;float:left;'></textarea>
				</el-form-item>
				<el-form-item style='background:none;' v-show='isShowCommon()'>
					<el-button class='aeMg' @click='cancel' type='' style=''>{{$t('app_cancel')}}</el-button>
					<el-button type='primary' style='' class='aeMg'
						@click="uploadApp('form')">{{$t('app_save')}}</el-button>
				</el-form-item>

				<el-form-item v-show='config.type === 2' label="" style='background:none;'>

					<el-button type='' @click='$router.go(-1)' style=''>{{$t('app_cancel')}}</el-button>
					<el-button type='primary' @click='lcNew' style=''>{{$t('app_upload') + 'launcher'}}</el-button>

				</el-form-item>

			</el-form>


		</div>
	</div>
</template>

<style>
	.contentColor {
		color: #495769
	}

	.avatarF {
		height: auto;
		width: 128px;
		display: block;
	}

	#ae {
		width: 100%;
		background: none;
	}




	#aeScreenCut img {
		height: 100%;
		width: auto;
	}

	/* upload */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.capture {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		width: 120px;
		display: inline-block;
	}

	.capture div {
		float: left;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #20a0ff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	/* upload */
	.sm-avatar-uploader-icon {
		font-size: 36px;
		color: #8c939d;
		width: 72px;
		height: 72px;
		line-height: 72px;
		text-align: center;
	}

	.sm-avatar {
		width: 64px;
		height: 64px;
		display: block;
	}

	#aeCpDiv {
		height: 180px;
		width: 120px;
		display: inline-block;
		background: none;
		margin-right: 10px;
	}

	.cImg {
		width: 100%;
	}
</style>

<script>
	import MechanismSelector from '@/components/global/mechanism_selector.vue'
	import mm from 'moment'
	import {
		urlAssets
	} from '@/api/url'
	import tyc from '@/components/global/tyc'
	export default {
		components: {
			MechanismSelector,
			tyc
		},
		data() {
			var that = this
			var tagCheck = (rule, value, callback) => {
				// console.log('checkValue ', value)
				if (!value) {
					callback(new Error(this.$t('noVerTag')));
				} else {
					callback()
				}
			}
			var versionCheck = (rule, value, callback) => {

				if (this.udFileType == 0 && rule.field == 'preVersion') {
					callback();
					return
				}

				var rg = /^\d+(\.\d+)+$/;
				if (!(rg.test(value))) {
					callback(new Error(this.$t('lin_global.bbhgsbd')));
				} else {
					callback();
				}

			};
			return {
				fileUploadUrl: "",
				tqobj: '',
				mechanismData: '',
				action: `${urlAssets.fileUrl}`,
				ulinfo: {
					tip: this.$t('app_ulNormalSt'),
					index: 0,
					icons: ['el-icon-upload', 'el-icon-circle-check', 'el-icon-close']
				},
				mechanismId: window.localStorage['mechanismId'],
				status: '',
				tipColor: {
					color: '#13CE66'
				},
				stModel: [{
						label: this.$t('app_online'),
						vl: '1'
					},
					{
						label: this.$t('app_offline'),
						vl: '2'
					},
					{
						label: this.$t('app_new'),
						vl: '0'
					}
				],
				channels: [],
				cmtypes: [],
				isbase: false,
				sftypes1: [],
				sftypes2: [],
				sftypes3: [],
				sftypes5: [],
				sftypes6: [],
				sftypes7: [],
				sftypes9: [],
				sftypes10: [],
				sftypes11: [],
				updateType: false,
				ftypes: '',
				ftypes_1: '',
				ftypes_2: '',
				ftail: {
					'1': ['zip'],
					'2': ['kos', 'hex', 'ksp', 'key', 'res', 'zip', 'rar'],
					'3': ['zip', 'img', 'png'],
					'5': ['cfg'],
					'6': ['ini', 'bin', 'rle', 'img', 'bz2', 'ksp','gz'],
					'7': [],
					'8': ['bz2'],
					'9': ['zimge', 'gz', 'fls', 'lod', 'bin'],
					'10': [],
					'11': ['ini', 'bin', 'rle', 'img', 'bz2', 'ksp','gz'],
				},
				channelId: '',
				rules: {
					name: [{
						required: true,
						message: this.$t('app_input'),
						trigger: 'blur'
					}],
					desc: [{
						required: true,
						message: this.$t('app_input'),
						trigger: 'blur'
					}],
					ftype: [{
						required: true,
						message: this.$t('app_select'),
						trigger: 'blur'
					}],
					stype: [{
						required: true,
						message: this.$t('app_input'),
						trigger: 'blur'
					}],
					mech: [{
						required: true,
						message: this.$t('app_select'),
						trigger: 'blur'
					}],
					url: [{
						required: true,
						message: this.$t('app_select'),
						trigger: 'blur'
					}],
					ver: [{
						required: true,
						message: this.$t('app_input'),
						trigger: 'blur',
						// validator: versionCheck
					}],
					bver: [{
						required: true,
						message: this.$t('lin_global.verTips1'),
						trigger: 'blur',
						validator: versionCheck
					}],
					// verTag: [
					//   {required: true, message: this.$t('app_inputVerTag'), trigger: 'blur', validator: tagCheck }
					// ],
				},
				form: {
					name: '',
					fname: '',
					dtype: 1,
					desc: '',
					ftype: '',
					stype: '',
					ver: '',
					url: '',
					md5: '',
					size: '',
					mech: '',
					bver: ''
				},
				showPic: {
					value: 0,
					data: ''
				},
				srchValue: '',
				installTypes: [{
					label: this.$t('app_autoInstall'),
					value: 0
				}],
				fileSize: 0, // 上传文件大小
				tableData: [],
				checkDesc: '',
				radio: '1',
				smImageUrl: '',
				bgImageUrl: '',
				dialogVisible: false,
				appTypes: [],
				loading: 0,
				loading1: 0,
				loadingBig: 0,
				loadingSm: 0,
				config: {},

				fileList: [],
				isUpload: 0,
				index: 1,
				total: 0
			}
		},
		computed: {

			isShowUpdateDesc() {
				if (this.config.data) {
					if (this.config.data.updatedesc) {
						return true
					} else {
						return false
					}
				} else {
					return false
				}
			},
			updateDescContent() {
				var vl = this.config.data ? this.config.data.updatedesc : ''
				// alert(this.config.data.updatedesc)
				return vl
			},
			prdes() {
				return (this.config.data) ? this.config.data.launcherDesc : ''
			},
			uData() {
				let result = {}
				if (this.form.ftype == 11) {
					result = {
						token: 1234,
						name: this.form.stype
					}
				} else {
					result = {
						token: 1234
					}
				}
				return result
			},
			imgUploadUrl() {
				// return this.$imgUploadUrl
				return this.$urls.picUrl
			},
			// fileUploadUrl() {
			// 	//return this.$launchUlUrl

			// 	// var vl = this.$urls.apkUrl + '?distributorId=' + localStorage.mechanismId + '&language=' + localStorage.system_lang
			// 	// return vl

			// 	return this.action
			// },
			reason() {
				if (!this.config.data) {
					return ''
				}
				var rs = this.config.data.auditContent
				return rs ? this.$t('app_banReason') + ':' + rs : this.$t('app_banReason') + ':' + this.$t('app_noInput')
			},
			isShowReason() {
				if (this.config) {
					if (this.config.data) {
						if (this.config.data.appStatus === '3') {
							return 1
						} else {
							return 0
						}
					} else {
						return 0
					}
				} else {
					return 0
				}
			}
		},
		methods: {
			// 修改设备类型
			change_device(data) {
				if (data == 1) {
					this.ftypes = this.ftypes_1;
				} else {
					this.ftypes = this.ftypes_2;
				}
				this.$nextTick(()=>{
					this.form.ftype = null;
					this.form.stype = null;
				})
				

			},
			jumpToTool() {
				window.open('https://tmsadmin.szzt.com.cn/szzt_utils/#/animationgen')
			},
			sfileTypeChange(vl) {
				if (vl == '1-1') {
					this.isbase = true
				} else
					this.isbase = false
			},
			fileTypeChange(vl) {
				this.form.stype = ''
				if (!vl) {

					this.cmtypes = ''
				} else {
					this.cmtypes = this['sftypes' + vl]
					console.log(this.action)
					if (vl == 6) {
						this.fileUploadUrl = this.action;
					} else if (vl == 11) {
						this.fileUploadUrl = this.action;
						// this.form.ver = "";
					} else {
						this.fileUploadUrl =
							"https://tmsadmin.szzt.com.cn/file-management/tms-server-web/file/fileupload.do"
					}
				}

			},
			lcNew() {
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.loading = 1
						var form = this.form
						this.$updateLauncher(this.form.md5, form.launcherName, form.launcherDesc, form.caps, form
							.appUrl, form.packageName, form.version, form.verTag, this.fileSize, this.config
							.data.launcherid, localStorage.mechanismId, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.$message.success(res.message)
									this.$router.go(-2)
								} else {
									this.$message.error(res.message)
								}
							}, () => {
								this.loading = 0
								this.$message(this.$t('app_rqsError'))
							})

					} else {
						return false
					}

				})
			},
			selectChange(vl) {
				// this.getDevices()
			},
			getChannels() {
				this.$getChannelList(10000, 1, '', '', '', (res) => {
					if (res.status === 200) {
						this.channels = res.data
					} else {
						this.$message.error(res.message)
					}
				}, () => {
					// error
					this.$message.error(this.$t('app_rqsError'))
				})
			},
			getStatus(value) {
				switch (value) {
					case '0':
						return this.$t('app_prePushVerify')
					case '1':
						return this.$t('app_preVerify')
					case '2':
						return this.$t('app_verifyPass')
					case '3':
						return this.$t('app_verifyNotPass')
				}
			},
			pageSelect(index) {
				this.index = index
				this.getDevices()
			},
			pageSized(val) {
				this.$gRow = val
				this.getDevices()
			},
			hBlur(name) {
				this.$refs[name].validate((valid) => {
					if (valid) {} else {
						return false
					}
				})
			},
			showBigPic() {
				this.showPic = {
					value: 1,
					data: this.imgFullUrl(this.config.data.appBigIcon)
				}
			},
			showScreenShot(path) {
				this.showPic = {
					value: 1,
					data: this.imgFullUrl(path)
				}
			},
			pushInstall() {
				this.dialogVisible = true
			},
			makeAppPath(url) {
				var path = url
				if (!path) {
					if (this.config.data) {
						path = this.config.data.appUrl
						if (!path) {
							return ''
						}
					} else {
						return ''
					}
				}
				var arr = path.split('/')
				return arr[arr.length - 1]
			},
			deleteAppHis(row) {
				// console.log(row)
				if (row.applicationid) {
					this.$confirm(this.$t('app_tipAppEdit'), this.$t('app_tip'), {
						confirmButtonText: this.$t('app_sure'),
						cancelButtonText: this.$t('app_cancel'),
						type: 'warning'
					}).then(() => {
						this.loading = 1
						if (this.$appUrlTag === 0) {
							this.$deleteApp(row.applicationid, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.getAppHistory()
								} else {
									this.$message.error(res.message)
								}
							}, () => {
								// error
								this.loading = 0
							})
						} else {
							this.$deleteApp1(row.applicationid, (res) => {
								this.loading = 0
								if (res.status === 200) {
									this.getAppHistory()
								} else {
									this.$message.error(res.message)
								}
							}, () => {
								// error
								this.loading = 0
							})
						}

					}).catch(() => {})
				}
			},
			dateFormat(row, column) {
				var date = row[column.property]
				if (date === undefined) {
					return ''
				}
				return mm(date).format('YYYY-MM-DD hh:mm:ss')
			},
			deleteCapture0() {
				this.cp0 = ''
				this.cp0Value = ''
			},
			deleteCapture1() {
				this.cp1 = ''
				this.cp1Value = ''
			},
			deleteCapture2() {
				this.cp2 = ''
				this.cp2Value = ''
			},
			deleteCapture3() {
				this.cp3 = ''
				this.cp3Value = ''
			},
			deleteCapture4() {
				this.cp4 = ''
				this.cp4Value = ''
			},
			imgFullUrl(path) {
				if (path) {
					// return this.$host + path
					return this.$urls.prefix + path
				} else {
					return ''
				}
			},
			close() {
				this.$router.go(-1)
			},
			isShowCommon(isShow) {
				// 新建为默认入框，编辑不显示输入框，其他
				if (isShow && (this.config.type === 2 || this.config.type === 3)) {
					return 1
				} else if (!isShow && (this.config.type !== 2 && this.config.type !== 3)) {
					return 1
				} else {
					return 0
				}
			},
			tipBf() {
				this.loading1 = 1
				return 1
			},
			handleSmAvatarSuccess(res, file) {
				// console.log(res)
				this.loadingSm = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.form.smImageUrlValue = res.data
					this.smImageUrl = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleBgAvatarSuccess(res, file) {
				this.loadingBig = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.form.bgImageUrlValue = res.data
					this.bgImageUrl = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp0(res, file) {
				this.loading1 = 0
				// console.log(res)
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp0Value = res.data
					this.cp0 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp1(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp1Value = res.data
					this.cp1 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp2(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp2Value = res.data
					this.cp2 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp3(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp3Value = res.data
					this.cp3 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			handleAvatarSuccessCp4(res, file) {
				this.loading1 = 0
				if (res.status !== 200) {
					this.$message.error(res.message)
				} else {
					this.cp4Value = res.data
					this.cp4 = URL.createObjectURL(file.raw)
					this.hBlur('form')
				}
			},
			beforeSmAvatarUpload(file) {
				var size = file.size / 1024
				if (size > 100) {
					this.$message.error(this.$t('app_fileOver') + '100k')
					return false
				}
				this.loadingSm = 1
				return true
			},
			beforeBgAvatarUpload(file) {
				var size = file.size / 1024
				if (size > 200) {
					this.$message.error(this.$t('app_fileOver') + '200k')
					return false
				}
				this.loadingBig = 1
				return true
			},
			handleRemove(file, fileList) {
				// console.log(file, fileList)
			},

			uploadApp(formName) {
				if (window[this.$route.path]) {
					this.$message.error(this.$t('app_appLoding'))
					return
				}

				this.$refs[formName].validate((valid) => {
					if (valid) {

						if (this.form.ftype == 6 || this.form.ftype == 8) {
							if (this.form.ver) {
								// var rg = /^\d+(\.\d+)+$/;
								var rg = /^[vV]\d+(\.\d+)+$/;
								if (!(rg.test(this.form.ver))) {
									this.$message.error(this.$t('app_fmVerIillegal1'))
									return
								}
							} else {
								this.$message.error(this.$t('app_inputCp'))
								return
							}
						}

						if (this.form.ftype == 1 || this.form.ftype == 2) {
							if (this.form.ver) {
								var rg = /^\d+(\.\d+)+$/;
								if (!(rg.test(this.form.ver))) {
									this.$message.error(this.$t('app_fmVerIillegal'))
									return
								}
							} else {
								this.$message.error(this.$t('app_inputCp'))
								return
							}
						}

						if (this.form.stype == '1-1') {
							if (this.form.bver) {
								var rg = /^\d+(\.\d+)+$/;
								if (!(rg.test(this.form.bver))) {
									this.$message.error(this.$t('app_fmVerIillegal'))
									return
								}
							} else {
								this.$message.error(this.$t('app_inputCp'))
								return
							}
						}

						if (this.form.ftype != 5 && this.form.ftype != 7 && this.form.ftype != 4 && this.form
							.ftype != 8 && this.form.ftype != 10) {
							if (!this.form.stype && this.form.ftype) {
								this.$message.error(this.$t('app_plsstype'))
								return
							}
						}

						this.loading = 1
						if (this.config.type === 1) {
							this.$editFile(this.config.data.fileId, this.form.name, this.form.ver, this.form.md5,
								this.form.size, this.form.url, this.form.ftype, this.form.stype, this.form
								.bver, this.form.mech, this.form.desc, (res) => {
									this.loading = 0
									if (res.status === 200) {
										this.$message.success(res.message)
										this.$router.go(-1)
									} else {
										this.$message(res.message)
									}
								}, () => {
									this.loading = 0
									this.$message(this.$t('app_rqsError'))
								})

						} else {

							this.$addFile(this.form.name, this.form.ver, this.form.md5, this.form.size, this.form
								.url, this.form.ftype, this.form.stype, this.form.bver, this.form.mech, this
								.form.desc, (res) => {
									this.loading = 0
									if (res.status === 200) {
										this.$message.success(res.message)
										this.$router.go(-1)
									} else {
										this.$message.error(res.message)
									}
								}, () => {
									this.loading = 0
									this.$message(this.$t('app_rqsError'))
								})

						}
					} else {
						return false
					}

				})
			},
			fileUploadSuccess(res, file) {
				window[this.$route.path] = ''
				console.log('file', res)
				this.ulinfo.tip = res.message
				if (res.status === 200) {
					if (this.form.ftype == 11) {
						this.form.ver = res.version;
					}

					this.form.fname = file.name
					this.form.url = res.fileUrl
					this.form.size = res.appSize
					this.form.md5 = res.md5

					this.fileList = [{
						name: file.name
					}]
					this.hBlur('form')
					this.ulinfo.index = 1
					this.tipColor = {
						color: '#13CE66'
					}
				} else {
					this.ulinfo.index = 2
					if (this.config.type !== 1) {
						this.fileList = [{}]
					} else {
						this.fileList = [{
							name: this.makeAppPath(this.config.data.appUrl)
						}]
						this.fileList = []
					}
					this.$message.error(res.message)
					this.tipColor = {
						color: '#FF4949'
					}
				}
			},
			fileBeforeUpload(file) {

				console.log('upload file: ' + file)
				var tail = file.name.split('.').pop()
				tail = tail.toLowerCase()
				
				if (this.form.ftype && file) {
					var is = false
					var tails = this.ftail[this.form.ftype]
					console.log(this.ftail)
					console.log(this.form.ftype)
					console.log(tails)
					// console.log('tails: ' + tails + '\n tail is ' + tail)
					tails.forEach(vl => {
						if (vl == tail) is = true
					})
					if (!is && tails.length > 0) {
						this.$message.error(this.$t('app_spfileis') + this.ftail[this.form.ftype].toString())
						return false
					}
				} else {

					this.$message.error(this.$t('app_plsltype'))
					return false
				}

				window[this.$route.path] = 1
				var ar = file.name.split('.')
				var type = ar[ar.length - 1]
			},
			fillEdit() {
				var data = this.config.data
				console.log('fffdata', data)
				this.form.name = data.fileName
				this.form.desc = data.memo
				this.form.ftype = data.fileType
				this.form.ver = data.fileVersion
				this.form.bver = data.param1
				this.form.url = data.fileUrl
				this.form.md5 = data.hashCode
				this.form.size = data.fileSize
				this.form.mech = data.mechId
				
				var that = this
				this.mechanismData = {
					value: data.mechName,
					callback(value) {
						that.form.mech = value
						that.selectChange(value)
					}
				}

				this.cmtypes = this['sftypes' + data.fileType]
				console.log('pts', this.cmtypes)
				var ffname = data.fileUrl ? data.fileUrl.split('/').pop() : ''
				this.fileList = [{
					name: ffname
				}]
				this.form.fname = ffname

				var _this = this
				setTimeout(() => {
					_this.form.stype = data.subFileType
				}, 800);


				this.ulinfo.index = 1
			},
			getTypeList() {
				this.$getAppTypeList(100000000, 1, (res) => {
					if (res.status === 200) {
						console.log(res)
						this.appTypes = res.data
					} else {
						this.$message(res.message)
					}
				}, '')
			},
			cancel() {
				// cancel
				this.$router.go(-1)
			},
			verify() {
				this.loading = 1
				var id = this.config.data.applicationid
				var passValue = (this.radio === '1') ? '2' : '3'
				var desc = this.checkDesc
				if (this.$appUrlTag === 0) {
					this.$verifyApp(localStorage.user, id, passValue, desc, (res) => {
						this.loading = 0
						if (res.status === 200) {
							this.$router.go(-1)
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						this.loading = 0
						this.$message.error(this.$t('app_rqsError'))
					})
				} else {
					this.$verifyApp1(this.mechanismId, localStorage.user, id, passValue, desc, (res) => {
						this.loading = 0
						if (res.status === 200) {
							this.$router.go(-1)
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						this.loading = 0
						this.$message.error(this.$t('app_rqsError'))
					})
				}

			},
			getAppHistory() {
				if (!this.config.data.launcherName) {
					return
				}
				console.log('pkg', this.config.data)
				this.loading = 1
				if (this.$appUrlTag === 0) {
					this.$getAppHistory(this.config.data.launcherName, this.config.data.packagename, (res) => {
						console.log('reslist', res)
						this.loading = 0
						if (res.status === 200) {
							this.tableData = res.data
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.loading = 0
					})
				} else {
					this.$getAppHistory1(this.mechanismId, this.config.data.packagename, (res) => {
						console.log('reslist', res)
						this.loading = 0
						if (res.status === 200) {
							this.tableData = res.data
						} else {
							this.$message.error(res.message)
						}
					}, () => {
						// error
						this.loading = 0
					})
				}

			},
			uploadNew() {
				// this.config = {type: 4, data: this.config}
				// 
				//this.$router.push({name: this.$t('menu.appManageSub.uploadNew')})
			},
			setInstallType(type) {
				return this.$installType[type]
			},
			init() {
				this.config = this.$getWObj().fileEdit
				console.log('config', this.config)
				// 0新建 1编辑 2新上传
				switch (this.config.type) {
					case 0:
						//this.getTypeList()
						var that = this
						this.mechanismData = {
							value: '',
							callback(value) {

								that.form.mech = value
								that.selectChange(value)
							}
						}
						break
					case 1:
						// this.getTypeList()
						this.fillEdit()
						break
					case 2:
						//this.getTypeList()
						// console.log(this.config.data.appScreenShot)
						// this.fillEdit()
						// this.form.appUrl = ''
						// this.fileList = []
						//this.getAppHistory()
						break
				}
			},
			getDevices() {
				var vl = this.srchValue ? this.srchValue : ''
				var channel = this.channelId ? this.channelId : ''
				var status = this.status ? this.status : ''
				this.loading = 1
				if (this.$appUrlTag === 0) {
					this.$getDevices(this.index, this.$gRow, channel, vl, status, '', this.config.data.applicationid, (
						res) => {
						console.log('dv', res)
						this.loading = 0
						if (res.data) {
							this.tableData = res.data
							this.total = res.total
						}
					}, () => {
						// error
						this.loading = 0
					})
				} else {
					this.$getDevices1(this.index, this.$gRow, localStorage.mechanismId, vl, status, '', this.config.data
						.applicationid, (res) => {
							console.log('dv', res)
							this.loading = 0
							if (res.data) {
								this.tableData = res.data
								this.total = res.total
							}
						}, () => {
							// error
							this.loading = 0
						})
				}

			},
			bindOperate(row) {
				// console.log('r', row)
				this.bind(row.terminalId, row.terminalNo)
			},
			bind(tId, tNo) {
				this.loading = 1
				if (this.$appUrlTag === 0) {
					this.$bindApp('0', tId, this.config.data.applicationid, (res) => {
						if (res.status === 200) {
							this.$message.success(this.$t('app_tipViewTask'))
						} else {
							this.$message.error(res.message)
						}
						this.loading = 0
					}, () => {
						// error
						this.loading = 0
					})
				} else {
					// console.log(localStorage.mechanismId, tNo)
					this.$verifyAppPush(localStorage.mechanismId, tNo, this.config.data.applicationid, (res) => {
						if (res.status === 200) {
							this.$message.success(this.$t('app_tipViewTask'))
						} else {
							this.$message.error(res.message)
						}
						this.loading = 0
					}, () => {
						// error
						this.loading = 0
					})
				}

			},
			srchDevice() {
				this.getDevices()
			}
		},
		mounted() {


			this.tqobj = {
				keys: ['nolcft', 'sftypes1', 'sftypes2', 'sftypes3', 'sftypes4', 'sftypes5', 'sftypes6', 'sftypes7',
					'sftypes9', 'sftypes11', 'nolcft_1', 'nolcft_2'
				],
				callback: (data) => {
					console.log(data)
					this.ftypes = data[10]  // 默认第一种
					this.sftypes1 = data[1]
					this.sftypes2 = data[2]
					this.sftypes3 = data[3]
					this.sftypes4 = data[4]
					this.sftypes5 = data[5]
					this.sftypes6 = data[6]
					this.sftypes7 = data[7]
					this.sftypes9 = data[8]
					this.sftypes11 = data[9]
					this.ftypes_1 = data[10]
					this.ftypes_2 = data[11]
					// 编辑
					if(this.config.type == 1){
						if(this.config.data.fileType == "11" || this.config.data.fileType == "6"){
							this.form.dtype = 2
							this.ftypes = this.ftypes_2
						}else{
							this.form.dtype = 1
							this.ftypes = this.ftypes_1
						}
					}
				}
			}
			this.init()
		}
	}
</script>


// WEBPACK FOOTER //
// edit.vue?7fee6074